import { createSelector } from '@reduxjs/toolkit';

interface RootState {
    forgetPassword: any; 
}

const selectForgetPasswordState = (state: RootState) => state.forgetPassword;

export const selectForgetPasswordLoading = createSelector(
    [selectForgetPasswordState],
    (forgetPasswordState) => forgetPasswordState.loading
);

export const selectForgetPasswordSuccess = createSelector(
    [selectForgetPasswordState],
    (forgetPasswordState) => forgetPasswordState.isSuccess
);

export const selectForgetPasswordError = createSelector(
    [selectForgetPasswordState],
    (forgetPasswordState) => forgetPasswordState.isError
);

export const selectForgetPasswordMessage = createSelector(
    [selectForgetPasswordState],
    (forgetPasswordState) => forgetPasswordState.message
);

export const selectForgetPasswordErrorMessage = createSelector(
    [selectForgetPasswordState],
    (forgetPasswordState) => forgetPasswordState.error
);
